module.exports = __webpack_public_path__ + "img/1486611888.263eb84b.jpg";